import React from "react"
import { Card, Image } from "semantic-ui-react"
import { Link } from "react-router-dom"
import "./styles/styles.css"

const CardCategory = (props) => {
  const { image, name, id } = props.array
  return (
    <div className='ContainerCardCategory'>
      <Card
        as={Link}
        to={`/products/${id}`}
        style={{ width: "98.5%" }}
        className='CardCategory'
      >
        <Image src={image} className='ImageCard customizableImage' />
      </Card>

      <Card.Header className='Header'>
        <p className='tituloHeaderCategory'> {name}</p>
      </Card.Header>
    </div>
  )
}

export default CardCategory
